import { ResourceOptions } from 'react-admin';
import { FaImage } from 'react-icons/fa';
import { Resources } from '../resource';

export { default as list } from './List';

export const name = Resources.smallBanners;
export const icon = FaImage;
export const options: ResourceOptions = {
  label: 'resource.smallBanners',
};
